import React from 'react';
import { withRouter } from 'next/router';
import PropTypes from 'prop-types';
import { Grid } from '@fuww/library/src/Grid';

import EventDetail from '../components/Events/EventDetail';
import eventQuery from '../lib/graphcms/queries/events/eventQuery.graphql';
import EventPage from '../lib/eventPage';
import withApollo from '../lib/apollo';

class Event extends EventPage {
  render() {
    const { router: { query: { slug } } } = this.props;

    return (
      <Grid>
        <EventDetail
          query={eventQuery}
          variables={{ slug }}
          context={{ source: 'GraphCMS' }}
          errorMessage="Error loading this event info"
        />
      </Grid>
    );
  }
}

Event.propTypes = {
  router: PropTypes.shape({}),
};

Event.defaultProps = {
  router: {},
};

export default withApollo(withRouter(Event));
